/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content/Details/Person/Title",
  onChange
  
}) {
let newProfessionalOtherPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'new_professional',
path: 'other.person.title',
})
let newProfessionalOtherPersonTitleChangeData = fromData.useDataChange({ viewPath,
context: 'new_professional',
path: 'other.person.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 data="new_professional.other.person.title"
 value={newProfessionalOtherPersonTitleValueData}
 onChange={newProfessionalOtherPersonTitleChangeData}
/>
{children}
</React.Fragment>)
}